<template>
  <div class="d-inline-block">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>mdi-plus-box-outline</v-icon>
        </v-btn>
      </template>
      <span>Create Game</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      max-width="1000"
      scrollable
    >
      <v-card :loading="cardPresetsLoading">
        <v-card-title class="text-h5">
          Create Game
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text
          class="py-4"
        >
          <v-form
            ref="form"
            v-model="valid"
            :disabled="cardPresetsLoading"
            lazy-validation
            @submit.prevent="handleSubmit"
          >
            <v-row>
              <v-col cols="12" md="12">
                <v-autocomplete
                  ref="league"
                  v-model="league"
                  :rules="[rules.required]"
                  :items="leagues"
                  item-text="league"
                  item-value="id"
                  label="League"
                  dense
                  outlined
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row dense class="mt-4">
              <v-col cols="12" md="5">
                <v-autocomplete
                  v-model="teama"
                  :rules="[rules.required]"
                  :items="leagueTeama"
                  :item-text="leagueTeamName"
                  item-value="id"
                  label="Team"
                  dense
                  outlined
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" class="text-center" md="2">
                <span class="text-overline my-2 mx-2 font-italic">vs</span>
              </v-col>
              <v-col cols="12" md="5">
                <v-autocomplete
                  v-model="teamb"
                  :rules="[rules.required]"
                  :items="leagueTeamb"
                  :item-text="leagueTeamName"
                  item-value="id"
                  label="Team"
                  dense
                  outlined
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="6" class="mt-4">
                <v-menu
                  v-model="schedule_date_menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="schedule_date"
                      :rules="[rules.required]"
                      label="Schedule Date"
                      hide-details="auto"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @keyup="schedule_date_menu=true"
                      @keydown="schedule_date_menu=false"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="schedule_date"
                    @input="schedule_date_menu = false"
                    :min="new Date().toISOString().substr(0, 10)"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="6" class="mt-4">
                <v-menu
                  ref="schedule_time_menu"
                  v-model="schedule_time_menu"
                  :close-on-content-click="false"
                  :return-value.sync="schedule_time"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="schedule_time"
                      :rules="[rules.required]"
                      label="Schedule Time"
                      hide-details="auto"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @keyup="schedule_time_menu=true"
                      @keydown="schedule_time_menu=false"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="schedule_time_menu"
                    v-model="schedule_time"
                    @click:minute="$refs.schedule_time_menu.save(schedule_time)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col cols="12" class="pb-0">
                <div class="d-flex flex-wrap align-center justify-space-between">
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">Card Preset</div>
                    <div class="grey--text text--darken-1 text-caption">
                      Adjust these quantities for this game only. Use 0 to exclude
                      a bet amount.
                    </div>
                  </div>

                  <v-btn
                    text
                    small
                    color="primary"
                    :disabled="!default_card_presets.length"
                    @click="resetCardPresets"
                  >
                    <v-icon left small>mdi-restore</v-icon>
                    Reset defaults
                  </v-btn>
                </div>
              </v-col>

              <v-col
                v-for="group in presetGroups"
                :key="group.id"
                cols="12"
                md="6"
              >
                <v-card outlined class="fill-height">
                  <v-card-title class="py-2 text-subtitle-1">
                    {{ group.label }}
                    <v-spacer></v-spacer>
                    <v-chip small color="primary" outlined>
                      {{ cardTotal(group.records) }} cards
                    </v-chip>
                  </v-card-title>

                  <v-divider></v-divider>

                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Bet amount</th>
                          <th class="text-center" style="width: 150px">
                            Card quantity
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="preset in group.records" :key="presetKey(preset)">
                          <td>{{ formatAmount(preset.amount) }}</td>
                          <td class="py-1">
                            <v-text-field
                              v-model.number="preset.card_quantity"
                              type="number"
                              min="0"
                              max="1000"
                              step="1"
                              dense
                              outlined
                              hide-details="auto"
                              :rules="[
                                cardQuantityRequired,
                                rules.numeric,
                                nonNegativeCardQuantity,
                                maximumCardQuantity,
                              ]"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>

              <v-col v-if="cardPresetsError" cols="12">
                <v-alert type="error" dense outlined class="mb-0">
                  {{ cardPresetsError }}
                </v-alert>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="6" class="mt-2">
                <v-btn
                  block
                  :disabled="!valid || cardPresetsLoading || !card_presets.length"
                  type="submit"
                  color="primary"
                  @click.prevent="handleSubmit"
                  :loading="createGameLoading"
                >
                  Create
                </v-btn>
              </v-col>

              <v-col cols="12" md="6" class="mt-2">
                <v-btn
                  block 
                  color="black"
                  outlined
                  class="me-2"
                  @click="dialog = false"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import formRules from '@/helpers/formRules'

export default {
  data: () => ({
    dialog: false,
    valid: true,
    rules: formRules,
    league: '',
    teama: '',
    teamb: '',
    schedule_date: '',
    schedule_date_menu: false,
    schedule_time: '',
    schedule_time_menu: false,
    card_presets: [],
    default_card_presets: [],
  }),
  computed: {
    ...mapState("ending_games", [
      "leagues",
      "teams",
      "cardPresetsLoading",
      "cardPresetsError",
      "createGameError",
      "createGameLoading",
    ]),
    presetGroups() {
      return [
        {
          id: 1,
          label: "Traditional",
          records: this.card_presets.filter((preset) => preset.bet_type_id === 1),
        },
        {
          id: 2,
          label: "Per Quarter",
          records: this.card_presets.filter((preset) => preset.bet_type_id === 2),
        },
      ]
    },
    leagueTeama() {
      return this.teams.filter((team) => {
        return team.league_id == parseInt(this.league) && team.id != this.teamb
      })
    },
    leagueTeamb() {
      return this.teams.filter((team) => {
        return team.league_id == parseInt(this.league) && team.id != this.teama
      })
    }
  },
  methods: {
    ...mapActions("ending_games", ["createGame", "getCardPresets"]),
    leagueTeamName: team => team.team_name + ' ' + team.team_alias,
    cardQuantityRequired(value) {
      return (
        (value !== "" && value !== null && value !== undefined) ||
        "This field is required."
      )
    },
    nonNegativeCardQuantity(value) {
      return Number(value) >= 0 || "The card quantity cannot be negative."
    },
    maximumCardQuantity(value) {
      return Number(value) <= 1000 || "The card quantity cannot exceed 1,000."
    },
    cardTotal(records) {
      return records.reduce(
        (total, preset) => total + Number(preset.card_quantity || 0),
        0,
      )
    },
    formatAmount(value) {
      return Number(value || 0).toLocaleString("en-PH")
    },
    presetKey(preset) {
      return `${preset.bet_type_id}-${preset.id}`
    },
    clonePresets(presets) {
      return presets.map((preset) => ({
        ...preset,
        card_quantity: Number(preset.card_quantity),
      }))
    },
    resetCardPresets() {
      this.card_presets = this.clonePresets(this.default_card_presets)
    },
    async loadCardPresets() {
      const presets = await this.getCardPresets()
      this.default_card_presets = this.clonePresets(presets)
      this.resetCardPresets()
    },
    async handleSubmit() {
      if (this.$refs.form.validate()) {
        const formData = new FormData()
        formData.append('league', this.league)
        formData.append('teama', this.teama)
        formData.append('teamb', this.teamb)
        formData.append('schedule_date', this.schedule_date)
        formData.append('schedule_time', this.schedule_time)
        formData.append(
          'card_presets',
          JSON.stringify(
            this.card_presets.map((preset) => ({
              config_id: preset.id,
              bet_type_id: preset.bet_type_id,
              card_quantity: preset.card_quantity,
            })),
          ),
        )

        if (!this.createGameLoading) {
          const res = await this.createGame(formData)

          if (!this.createGameError) {
            this.$refs.form.reset()

            this.$router.push({ name: "EndingGameDetails", params: { id: res.game_id } })
          }
        }
      }
    }
  },
  watch: {
    async dialog(visible) {
      if (visible) {
        await this.loadCardPresets()

        setTimeout(() => {
          if (this.$refs.league) {
            this.$refs.league.focus()
          }
        }, 200);
      }
    }
  }
}
</script>
